export const IDENTITY_CONFIG = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  protocol: process.env.REACT_APP_PROTOCOL,
  clientId: process.env.REACT_APP_IDENTITY_CLIENT_ID,
  clientSecuirity: process.env.REACT_APP_ATHOURIZATION_URI,
  baseApiUrl: process.env.REACT_APP_BASE_API_URL,
};
